<template>
    <div class="parent-management-container container">
      <el-card shadow="hover">
        <template #header>
          <div class="card-header">
            <h2>إدارة أولياء الأمور</h2>
          </div>
        </template>
  
        <el-alert
          title="متابعة حسابات أولياء الأمور"
          type="info"
          description="من هذه الواجهة يمكنك متابعة بيانات أولياء الأمور، وإنشاء حسابات مستخدمين لهم للوصول إلى بوابة المدرسة الإلكترونية."
          :closable="false"
          show-icon
          style="margin-bottom: 20px;"
        />
        
        <div class="filter-section">
          <el-input
            v-model="filters.search"
            placeholder="ابحث باسم ولي الأمر..."
            @input="handleSearch"
            clearable
            style="width: 300px; margin-bottom: 20px;"
          />
        </div>
  
        <div class="legend" style="margin-bottom: 20px; display: flex; gap: 20px; align-items: center;">
          <span style="display: flex; align-items: center; gap: 8px;">
            <div style="width: 15px; height: 15px; background-color: #f0f9eb; border: 1px solid #e1f3d8; border-radius: 3px;"></div>
            <span>لديه حساب مستخدم</span>
          </span>
          <span style="display: flex; align-items: center; gap: 8px;">
            <div style="width: 15px; height: 15px; background-color: #fef0f0; border: 1px solid #fde2e2; border-radius: 3px;"></div>
            <span>لا يوجد حساب</span>
          </span>
        </div>
  
        <el-table :data="parents" v-loading="loading" border style="width: 100%" :row-class-name="tableRowClassName">
    
    <el-table-column label="اسم ولي الأمر" min-width="180">
        <template #default="{ row }">
            {{ row.first_name }} {{ row.last_name }}
        </template>
    </el-table-column>

    <el-table-column label="اسم المستخدم" min-width="150">
        <template #default="{ row }">
            {{ row.user ? row.user.username : '---' }}
        </template>
    </el-table-column>

    <el-table-column label="هاتف الحساب" width="150">
        <template #default="{ row }">
            {{ row.user ? row.user.phone : '---' }}
        </template>
    </el-table-column>

    <el-table-column prop="phone_number_one" label="رقم الهاتف الأساسي" width="150" />
    <el-table-column prop="email" label="البريد الإلكتروني" min-width="200" />
    
    <el-table-column label="عدد الأبناء" width="150" align="center">
    <template #default="{ row }">
        <el-button 
            v-if="row.students && row.students.length > 0" 
            size="small" 
            @click="showStudentsDetails(row)"
            link
            type="primary"
        >
            ({{ row.students.length }}) أبناء - عرض
        </el-button>
        <span v-else>(0) أبناء</span>
    </template>
</el-table-column>
    
    <el-table-column label="حالة الحساب" width="140" align="center">
        <template #default="{ row }">
            <el-tag :type="row.user ? 'success' : 'danger'" effect="light">
                {{ row.user ? 'مسجل' : 'غير مسجل' }}
            </el-tag>
        </template>
    </el-table-column>
    
    <el-table-column label="الإجراءات" width="180" fixed="right" align="center">
      <template #default="{ row }">
        <el-button v-if="!row.user" size="small" type="primary" @click="openCreateUserDialog(row)">
            <el-icon><Plus /></el-icon> إنشاء مستخدم
        </el-button>
        <span v-else>-</span>
      </template>
    </el-table-column>
</el-table>
  
        <div class="pagination-container">
          <el-pagination
            v-if="pagination.total > 0"
            @current-change="handlePageChange"
            :current-page="pagination.current_page"
            :page-size="pagination.per_page"
            :total="pagination.total"
            layout="total, prev, pager, next"
            background
          />
        </div>
      </el-card>

      <el-dialog v-model="studentsDialogVisible" :title="`أبناء ولي الأمر: ${selectedParentName}`" width="60%">
      <el-table :data="selectedParentStudents" border style="width: 100%">
        <el-table-column prop="srn" label="رقم القيد (SRN)" width="120" />
        <el-table-column prop="name" label="اسم الطالب" min-width="180" />
        <el-table-column label="الفصل" width="150">
          <template #default="{ row }">
            {{ row.class ? row.class.name : 'غير محدد' }}
          </template>
        </el-table-column>
        <el-table-column label="القسم" width="120">
          <template #default="{ row }">
            {{ row.section ? row.section.name : 'غير محدد' }}
          </template>
        </el-table-column>
      </el-table>
      <template #footer>
        <span class="dialog-footer">
          <el-button @click="studentsDialogVisible = false">إغلاق</el-button>
        </span>
      </template>
    </el-dialog>
  
      <el-dialog v-model="dialogVisible" title="إنشاء حساب مستخدم جديد" width="40%" :close-on-click-modal="false">
        <el-form :model="form" ref="formRef" label-position="top" :rules="rules">
          <el-alert :title="`سيتم ربط هذا الحساب بولي الأمر: ${selectedParentName}`" type="info" :closable="false" style="margin-bottom: 20px;" />
          <el-form-item label="اسم المستخدم" prop="username">
            <el-input v-model="form.username" placeholder="يُفضل استخدام رقم الهاتف كاسم مستخدم" />
          </el-form-item>
          <el-form-item label="رقم الهاتف" prop="phone">
            <el-input v-model="form.phone" placeholder="سيتم استخدامه لملف المستخدم" />
          </el-form-item>
          <el-form-item label="البريد الإلكتروني" prop="email">
            <el-input v-model="form.email" />
          </el-form-item>
          <el-form-item label="كلمة المرور" prop="password">
            <el-input v-model="form.password" type="password" show-password />
          </el-form-item>
        </el-form>
        <template #footer>
          <span class="dialog-footer">
            <el-button @click="dialogVisible = false">إلغاء</el-button>
            <el-button type="primary" @click="submitUserForm" :loading="formLoading">إنشاء الحساب</el-button>
          </span>
        </template>
      </el-dialog>
    </div>
  </template>
  
  <script>
  import axios from 'axios';
  import { ElMessage } from 'element-plus';
  import { Plus } from '@element-plus/icons-vue';
  import debounce from 'lodash/debounce';
  
  export default {
    name: 'ParentManagement',
    components: { Plus },
    data() {
      return {
        api: null,
        loading: true,
        parents: [],
        filters: { search: '' },
        pagination: { current_page: 1, per_page: 15, total: 0 },
        
        dialogVisible: false,
        formLoading: false,
        selectedParentName: '',
        studentsDialogVisible: false,
        selectedParentStudents: [],
        form: this.getInitialForm(),
        rules: {
          username: [{ required: true, message: 'اسم المستخدم مطلوب', trigger: 'blur' }],
          phone: [{ required: true, message: 'رقم الهاتف مطلوب لإنشاء الحساب', trigger: 'blur' }],
          email: [{ required: true, type: 'email', message: 'بريد إلكتروني صالح مطلوب', trigger: 'blur' }],
          password: [{ required: true, min: 8, message: 'كلمة المرور يجب أن تكون 8 أحرف على الأقل', trigger: 'blur' }],
        }
      };
    },
    created() {
      this.api = axios.create({ baseURL: process.env.VUE_APP_API_BASE_URL || 'https://cale.caledonian.ly/api' });
      this.api.interceptors.request.use((config) => {
        const token = localStorage.getItem('access_token');
        if (token) config.headers['Authorization'] = `Bearer ${token}`;
        return config;
      });
      this.fetchParents();
    },
    methods: {
   // التعديل هنا

   showStudentsDetails(parent) {
      this.selectedParentName = `${parent.first_name} ${parent.last_name}`;
      this.selectedParentStudents = parent.students;
      this.studentsDialogVisible = true;
    },
getInitialForm() {
  return { 
    parent_id: null, 
    name: '', 
    username: '', 
    email: '', 
    password: '', 
    user_type: 'parent',
    phone: '', // <-- إضافة هذا السطر
    address: '' // <-- إضافة هذا السطر
  };
},
      async fetchParents() {
        this.loading = true;
        try {
          const params = { ...this.filters, page: this.pagination.current_page, per_page: this.pagination.per_page };
          const response = await this.api.get('/parents-account', { params });
          this.parents = response.data.data;
          this.pagination.total = response.data.total;
          this.pagination.current_page = response.data.current_page;
        } catch (error) {
          ElMessage.error('فشل في جلب بيانات أولياء الأمور.');
          console.error("Error fetching parents:", error);
        } finally {
          this.loading = false;
        }
      },
      handleSearch: debounce(function() {
        this.pagination.current_page = 1;
        this.fetchParents();
      }, 500),
      handlePageChange(page) {
        this.pagination.current_page = page;
        this.fetchParents();
      },
// التعديل هنا
openCreateUserDialog(parent) {
  this.form = this.getInitialForm();
  this.form.parent_id = parent.id;
  this.form.name = `${parent.first_name} ${parent.last_name}`;
  this.form.email = parent.email || '';
  this.form.username = parent.phone_number_one || '';

  this.form.phone = parent.phone_number_one || ''; // <-- إضافة هذا السطر
  this.form.address = parent.address || 'N/A'; // <-- إضافة هذا السطر

  this.selectedParentName = `${parent.first_name} ${parent.last_name}`;
  this.dialogVisible = true;
},
      async submitUserForm() {
        this.$refs.formRef.validate(async (valid) => {
          if (!valid) return;
  
          this.formLoading = true;
          try {
            await this.api.post('/users-account', this.form);
            ElMessage.success('تم إنشاء حساب المستخدم بنجاح!');
            this.dialogVisible = false;
            this.fetchParents(); // تحديث القائمة لإظهار الحالة الجديدة
          } catch (error) {
            const errorMsg = error.response?.data?.message || 'فشل في إنشاء الحساب.';
            ElMessage.error(errorMsg);
          } finally {
            this.formLoading = false;
          }
        });
      },
      tableRowClassName({ row }) {
        if (row.user) {
          return 'has-user-row';
        }
        return 'no-user-row';
      }
    },
  };
  </script>
  
  <style>
  .el-table .has-user-row {
    --el-table-tr-bg-color: #f0f9eb;
  }
  .el-table .no-user-row {
    --el-table-tr-bg-color: #fef0f0;
  }
  </style>